import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  Card,
  Fade,
} from '@mui/material';
import useFadeOpen from './useFadeOpen';

type PropType = {
  open: boolean;
  estimatedMinutes: number;
  onGoToDashboard: () => void;
};

const ThankYouModal: React.FC<PropType> = ({
  open,
  estimatedMinutes,
  onGoToDashboard,
}) => {
  const showContent = useFadeOpen(open);

  return (
    <Modal
      open={open}
      closeAfterTransition
      disableEscapeKeyDown
      slotProps={{
        backdrop: {
          timeout: 400,
          sx: { backgroundColor: 'rgba(0, 0, 0, 0.45)' },
        },
      }}
    >
      <Fade in={showContent} timeout={400}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 'calc(100% - 32px)',
            maxWidth: '450px',
            outline: 'none',
          }}
        >
          <Card
            sx={{
              borderRadius: 4,
              p: 3,
              boxShadow: 24,
            }}
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap={3}
              textAlign="center"
            >
              <Typography
                variant="body1"
                sx={{ color: '#222222', fontSize: '1.1rem' }}
              >
                {`Thank you, your list should be complete within approximately ${estimatedMinutes}min.`}
              </Typography>
              <Button
                variant="contained"
                fullWidth
                sx={{ py: 1.5, borderRadius: 2 }}
                onClick={onGoToDashboard}
              >
                Go To Dashboard
              </Button>
            </Box>
          </Card>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ThankYouModal;
